import { Form, Input, Pagination, Select } from 'antd';
import React, { useEffect, useState } from 'react'
import NoRecordFound from '../../components/common/NoRecordFound';
import { EditTwoTone } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { useNavigate } from 'react-router-dom';
import { app } from '../../config';
import axios from 'axios';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';

const PaymentList = () => {
    const { Search } = Input;
    let user = JSON.parse(localStorage.getItem('user'));
    const { t } = useTranslation(['common']);
    const [form] = Form.useForm();
    const [payments, setPayments] = useState([]);
  const [renderList, setRenderList] = useState([]);
  const [current, setCurrent] = useState(1);
  const [commonData, setCommonData] = useState([]);
  const [pagesCount, setPagesCount] = useState(0);
  const [paymentlink, setPaymentlinks] = useState([]);
  const [orgdata, setOrgData] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [pageObj, setPageObj] = useState({});
  const [clearSearch, setClearSearch] = useState(false);

  const navigate = useNavigate();


  console.log(("useFetchOrganizations", useFetchOrganizations()))
  const orgResp = useFetchOrganizations();
  const token = getTokenfromUserObj();
  
  let orgObj = orgResp.response ? orgResp.response.data : [];

  const handleClearClick = () => {
    console.log('Clear search called');
    setOrgData(); 
    form.resetFields();
    console.log(document.getElementById('search').value);
    document.getElementById('search').value = null;
    document.getElementById('search').innerHTML = null;
    setClearSearch(true);
    
  };

  const handleSearchChange = (e) => {
    console.log(e.target.value);
    if (!e.target.value) {
      setRenderList(paymentlink.slice(0, 10));
      setCommonData(paymentlink);
      setPagesCount(paymentlink.length);
    }else{
      setSearchValue(e.target.value)
    }
  };

  const onChange = async (page, pageSize) => {
    console.log("page, pageSize",page, pageSize);
    setCurrent(page);
    if (!page) page = 1;
    let limit = pageSize;
    let reqObj = {
      limit,
      offset: limit * (page - 1),
    };
    console.log("reqObj",reqObj);
    setPageObj(reqObj);
    // setRenderList(commonData.slice(reqObj.offset, reqObj.offset + limit));
  };


  const onFinish = (values) => {
    console.log('Success:', values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const addPayment = (e) => {
    console.log(e);
    if (user.userType === 'A') navigate('/paymentlink/add', { replace: true });
    else if (user.userType === 'O') navigate('/paymentlink/add', { replace: true });
  };

  const editPayment = (p) => {
    console.log(p);
    localStorage.setItem('paymentLinkId', JSON.stringify(p.id));
    if (user.userType === 'A') navigate('/paymentlink/edit', { replace: true });
    else if (user.userType === 'O') navigate('/paymentlink/edit', { replace: true });
  };

  const onSearch = async (value) => {
  //  if(searchValue){
    console.log(value);
    let limit = 10;
    let offset = 0
    let searchtxt = searchValue ? `&searchTxt=${searchValue}` : "";
    try {
      console.log(`${app.URL}/paymentlink/view?limit=${pageObj.limit || limit}&offset=${pageObj.offset || offset}${searchtxt}`);
      // const result = await axios.get(`${app.URL}/paymentlink/view?limit=${pageObj.limit || limit}&offset=${pageObj.offset || offset}&searchTxt=${searchValue}`, { headers: { auth: token } });
      const result = await axios.get(`${app.URL}/paymentlink/view?limit=${pageObj?.limit || limit}&offset=${pageObj?.offset || offset}${searchtxt}`, { headers: { auth: token } });

      console.log("result", result.data.data);
      let convertedObj;
      // result.data ? (convertedObj = dateConverter(result.data.data, 'startDate')) : ' ';
      // convertedObj = dateConverter(convertedObj, 'endDate');
      result.data ? setCommonData(convertedObj) : [];
      result.data ? setRenderList(result.data.data.data) : [];orgObj
      result.data ? setPagesCount(result.data.data.count) : 0;
    } catch (e) {
      console.log('Error');
      console.log(e);
      // if (e.message) setErr(e.response.data.message);
      // setTableShow(false);
    }
  // }
  };

  // useEffect(()=>{
  // if(searchValue){
  //   onSearch()
  // }
  // }, [pageObj])
  

  useEffect(() => {
    onSearch()
  }, [pageObj])
  const selectOrgId = (e) => {
    console.log('Select org Id');
    setOrgData(e);
  };
  console.log("paymentlink/view", pageObj)
    return (
        <div className='ml-3 col-lg-12 col-md-12 col-sm-12'>
          <div className='row'>
            <div className='col-lg-8 col-md-8 col-sm-12 '>
              <div class='mt-4 fs-3 fw-bold'> {t('Payment List')} </div>
            </div>
    
           {user.userType==="A"?
            <Form
              name='basic'
              form={form}
              initialValues={{
                remember: true,
              }}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              autoComplete='off'
            >
              <div className='row text-left mt-4 mt-2'>
              <div className='col-lg-3 eventselect'>
              <Form.Item
                      form={form}
                      colon={false}
                      name='organizationId'
                      rules={[
                        {
                          required: false,
                          message: 'Select Organization',
                        },
                      ]}
                    >
                      <Select
                        className='custom-select-dropdown'
                        listHeight={250}
                        listItemHeight={500}
                        onChange={selectOrgId}
                        style={{
                          display: 'inline-block ',
                        }}
                        placeholder='Select Organization'
                      >
                        {orgObj.map((orgs) => {
                          return (
                            <Option 
                            className="select-option"
                            key={orgs.organizationId} value={orgs.organizationId}>
                              {orgs.organizationName}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
              </div>
              <div className='col-lg-2'>
              <button class='btn btn-primary button' onClick={handleClearClick}>
                        Clear
                      </button>
              </div>
              <div className='col-lg-3'>
              <Form.Item>
                        <Search
                          id='search'
                          className='payment-search'
                          placeholder='Search by Title'
                          onSearch={onSearch}
                          onChange={handleSearchChange}
                          style={{
                            width: 300,
                            height:50
                          }}
                        />
                      </Form.Item>
              </div>
                <div className='col-lg-3 offset-lg-1 text-center col-md-4 col-sm-12'>
                  <button class='btn btn-primary button' onClick={addPayment}>
                    Add Payment
                  </button>
                </div>
              </div>
            </Form> :" "}
            {user.userType==="O"?
               <Form
               name='basic'
               form={form}
               initialValues={{
                 remember: true,
               }}
            //    onFinish={onFinish}
            //    onFinishFailed={onFinishFailed}
               autoComplete='off'
             >
               <div className='row text-right mt-4 mt-2'>
               <div className='col-lg-4 eventSelect'>
        
               </div>
               <div className='col-lg-4'>
               <Form.Item>
                         <Search
                           id='search'
                           className='payment-search'
                           placeholder='Search by Title'
                           
                           style={{
                             width: 300,
                             height:50
                           }}
                         />
                       </Form.Item>
               </div>
                 <div className='col-lg-2 offset-lg-1 text-center col-md-4 col-sm-12'>
                   <button class='btn btn-primary button' onClick={addPayment}>
                     Add Payment
                   </button>
                 </div>
               </div>
             </Form>:" "}   
          </div>
          <div className='col-lg-11 col-md-12 col-sm-12 '>
            {/* <div class=' styled-table '> */}
            <div class=' styled-table '>
              <table class='table text-black'>
                <thead class='thead-light'>
                  <tr>
                    {/* <th>{t("ID")}</th> */}
                    {user.userType === 'A' ? <th>{t('Organization')}</th> : ' '}
                    <th>{t('Payment Url')}</th>
                    <th className='text-center'>{t('Expiry Date')}</th>
                    <th>{t('Active')}</th>
                    {/* <th>{t('Description')}</th> */}
                    {/* <th>{t('Status')}</th> */}
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  {renderList
                    ? renderList.map((output) => (
                     
                        <tr
                        //   onClick={() => {
                        //     editEvents(output);
                        //   }}
                        >
                          {/* <td style={{width:"100px"}}>{output.eventsId}</td> */}
                          {/* onClick={()=>{editUser(output)}} style={{color:"blue",textDecoration:"underline", width:"160px"}} */}
                          {user.userType === 'A' ? <td style={{ width: '200px' }}>{output.organization_name}</td> : ' '}
                          <td style={{ width: '200px' }}>{output.payment_url ? output.payment_url : 'null'}</td>
                        {/* <td style={{ width: '200px' }}>{output.id ? output.id : 'null'}</td> */}
                          <td style={{ width: '200px' }} className='text-center'>
                            {output.expiry_date ? output.expiry_date.split('T')[0] : "null"}
                          </td>
                          
                          {/* <td style={{ width: '200px' }}>{output.description.slice(0, 50)}</td> */}
                          <td style={{ width: '80px' }}>{output.is_active === 1 ? "Active" : "Not Active"}</td>
                          <td style={{ width: '20px' }}>
                            <EditTwoTone
                              displayName='edit'
                              twoToneColor='blue'
                              style={{ fontSize: '20px' }}
                              onClick={() => {
                                editPayment(output);
                              }}
                            />
                            {/* <button type='button' style={{ display: editbtn }} class='btn btn-primary color1 button' onClick={() => editOrg(output)}>
                             {t('Edit')}
                           </button> */}
                          </td>
                        </tr>
                      ))
                    : ' '}
                </tbody>
              </table>
              {renderList&&renderList.length == 0?<NoRecordFound/>:" "}
            </div>
          </div>
          <Pagination style={{ marginTop: '10px' }} onChange={onChange} defaultCurrent={current} pageSize={10} total={pagesCount} />
        </div>
        // </div>
      );
}

export default PaymentList